module.exports = __webpack_public_path__ + "img/60.2.TN.38d36e1e.png";